import { Layout } from "antd";
import OfferLetterBody from "../../components/offer-letter/OfferLetterBody";

const OfferLetter = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh", paddingLeft: "20px", paddingRight: "20px" }} className="max-w-6xl w-full mx-auto">
        <OfferLetterBody />
      </Layout>
    </>
  );
};

export default OfferLetter;
